import React, { useState } from 'react';
import { shapeColours } from '../../util/brand';

const Svg = ({ frameColour, frameIndex }) => {
  switch (frameIndex) {
    case (0):
      return (
        <svg viewBox="0 0 126 126" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path
            d="M122.433 3.236c1.608 1.856 2.076 37.774 2.23 42.108 1.345 37.928-.072 42.761-.072 49.443 0 19.427 3.091 22.855 0 25.708-3.092 2.852-36.48 3.453-56.798 3.453-5.431 0-19.693 1.908-27.826 1.729-12.149-.268-32.288-1.934-35.766-5.182C2.118 118.55.908 79.679 1.124 45.344 1.268 22.351-.328 7.555 4.2 3.236c4.53-4.319 14.695-.42 31.202-.448C51.244 2.762 68.311.562 82.914.694c27.346.248 36.958-.413 39.519 2.542z"
            fill={frameColour}
            fillRule="evenodd"
          />
        </svg>
      );
    case (1):
      return (
        <svg viewBox="0 0 126 126" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path
            d="M3.1 6.308C5.106 4.9 9.774 4.565 14.098 4.411 51.936 3.07 75.791 2.26 87.386 2.26c19.381 0 29.846-3.083 32.692 0 2.845 3.083 3.445 36.384 3.445 56.649 0 5.417 1.903 19.641 1.724 27.752-.267 12.117 1.516 34.44-1.724 37.91-1.94 2.076-44.164 1.047-78.416.832-22.938-.144-39.37 1.636-40.812-.833-.957-1.638-3.703-14.415-3.73-30.88-.026-15.799-.132-35.736 0-50.301C.812 16.114 2.14 6.982 3.1 6.308z"
            fill={frameColour}
            fillRule="evenodd"
          />
        </svg>
      );
    case (2):
      return (
        <svg viewBox="0 0 125 126" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path
            d="M.96 5.522C2.97 4.11 11 4.207 15.333 4.052c37.92-1.346 61.833-2.631 73.453-2.631 19.423 0 32.874-3.296 34.545 2.507C125 9.732 125 37.934 125 58.27c0 5.437-.678 31.818-.857 39.958-.267 12.16 2.433 22.456-.813 25.936-1.945 2.085-42.589 1.052-76.915.836-22.987-.144-44.01 1.642-45.454-.836-.96-1.644.842-14.466.815-30.989C1.751 77.32-.126 58.026.006 43.41.255 16.04 0 6.2.962 5.522z"
            fill={frameColour}
            fillRule="evenodd"
          />
        </svg>
      );
    case (3):
      return (
        <svg viewBox="0 0 125 126" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path
            d="M.453 8.647C2.35 7.207 10.149 7.054 14.35 6.77c36.763-2.488 59.93-4.482 71.212-4.843 18.857-.603 31.792-4.23 33.63 1.37 1.837 5.6 2.885 33.065 3.64 52.87.202 5.295.525 31.008.653 38.94.192 11.851 3.197 21.795.174 25.285-1.81 2.09-41.307 2.346-74.64 3.201-22.321.573-42.664 2.965-44.158.597-.992-1.572.28-14.115-.36-30.205C3.887 78.545 1.35 59.812.934 45.573.158 18.91-.456 9.335.453 8.647z"
            fill={frameColour}
            fillRule="evenodd"
          />
        </svg>
      );
    default:
      return null;
  }
};

const FrameSvg = ({ frameHex = null }) => {
  const [randColourIndex] = useState(Math.floor(Math.random() * shapeColours.length));
  const [randFrameIndex] = useState(Math.floor(Math.random() * 4));
  const colour = !frameHex ? shapeColours[randColourIndex] : frameHex;
  return (
    <div className="frame-svg">
      <Svg
        frameIndex={randFrameIndex}
        frameColour={colour}
      />
    </div>
  );
};

export default FrameSvg;
